module.exports = __webpack_public_path__ + "static/media/green infra.1a3c4a4f.jpg";